import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../toolkit/uicomponentcss';
import { Colors } from '../../../utils/resources/colors';

export interface PopUpWrapperCSSStyle extends UIComponentCSSStyle
{
    getContentDivCSSStyle(): object;
    getMobileContentDivCSSStyle():object;
}

export class PopUpWrapperCSSStyleImpl extends UIComponentCSSStyleImpl implements PopUpWrapperCSSStyle
{   

    // setChildComponentWidth(width: string)
    // {
    //     this.width = width;
    // }

    getWrapperCSSStyle(): object
    {
        return {
            display: "display", /* Hidden by default */
            position: "fixed", /* Stay in place */
            zIndex: 2000, /* Sit on top */
            left: 0,
            // bottom:'0',
            top: '0px',
            width: "100%", /* Full width */
            height: "100%", 
            overflow: "auto", /* Enable scroll if needed */
            // opacity: 0.4,
            // backgroundColor: this.getResources().getColor(Colors.color_4), /* Fallback color */
            backgroundColor: "rgba(0,0,0,0.4)" /* Black w/ opacity */
        };
    }

    getContentDivCSSStyle(): object
    {
        return {
            position: "relative",
            // backgroundColor: this.getResources().getColor(Colors.color_5),
            // margin: "auto",
            padding: 0,
            top:'-15%',
            borderRadius: "8px",
            zIndex: 2001,
            overflow: "visible",
            // width: "440px",
            // marginTop: "120px", 
            // marginBottom: "171px",
            animationName: "animatetop",
            animationDuration: "0.4s"
        };
    }

    getMobileContentDivCSSStyle(): object
    {
        return {
            position: "relative",
            backgroundColor: this.getResources().getColor(Colors.color_5),
            // marginLeft: "30px",
            padding: 0,
            top:'-15%',
            borderRadius: "8px",
            zIndex: 2001,
            overflow: "visible",
            // marginRight: "30px",
            // marginTop: "220px", 
            // marginBottom: "171px",
            animationName: "animatetop",
            animationDuration: "0.4s"
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/popupwrappercss.tsx